__turbopack_context__.v({
  "cardCarousel": "TemplateCard-module-scss-module__rbDVda__cardCarousel",
  "cardCarouselMobile": "TemplateCard-module-scss-module__rbDVda__cardCarouselMobile",
  "cardContainer": "TemplateCard-module-scss-module__rbDVda__cardContainer",
  "cardShadow": "TemplateCard-module-scss-module__rbDVda__cardShadow",
  "cardWrapper": "TemplateCard-module-scss-module__rbDVda__cardWrapper",
  "fade": "TemplateCard-module-scss-module__rbDVda__fade",
  "gif": "TemplateCard-module-scss-module__rbDVda__gif",
  "gifHidden": "TemplateCard-module-scss-module__rbDVda__gifHidden",
  "gifVisible": "TemplateCard-module-scss-module__rbDVda__gifVisible",
  "hovered": "TemplateCard-module-scss-module__rbDVda__hovered",
  "image": "TemplateCard-module-scss-module__rbDVda__image",
  "logoBackground": "TemplateCard-module-scss-module__rbDVda__logoBackground",
  "mobileCardActions": "TemplateCard-module-scss-module__rbDVda__mobileCardActions",
  "skeletonLineStyle": "TemplateCard-module-scss-module__rbDVda__skeletonLineStyle",
  "skeletonRectStyle": "TemplateCard-module-scss-module__rbDVda__skeletonRectStyle",
  "template": "TemplateCard-module-scss-module__rbDVda__template",
  "templateCardActionButton": "TemplateCard-module-scss-module__rbDVda__templateCardActionButton",
  "templateCardActionButtonHover": "TemplateCard-module-scss-module__rbDVda__templateCardActionButtonHover",
  "textColor": "TemplateCard-module-scss-module__rbDVda__textColor",
});
